<script>
import api from '@utils/api'

export default {
  name: 'GoodsLoadCSV',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      valid: false,
      group: null,
      file: null,
      rules: {
        isRequired: [x => !!x || this.$t('validation__is_required')],
      },
      formats: [
        `"full_name","short_name","article_number","description","employer_id","characteristic_121"`,
        '',
        '',
        `"full_name","short_name","article_number","description","employer_id","characteristic_114","characteristic_112","characteristic_113","characteristic_118","characteristic_119"`,
      ],
      result: null,
    }
  },
  computed: {
    goodsGroup() {
      const groups = this.$store.getters['data/getDictionary']('goodsgroup')
      if (!groups) return []
      return groups.filter(item => item.code !== 2 && item.code !== 100)
    },
  },
  watch: {
    // group(v) {
    //   if (!v) return
    //   if (this.file)
    //     this.checkFileFormat(this.file).then(response => {
    //       if (!response) {
    //         this.$refs.file.value = null
    //         this.file = null
    //         this.valid = false
    //       }
    //     })
    // },
  },
  methods: {
    onFilePicked(event) {
      const file = event.target.files[0] || event.dataTransfer.files[0]
      if (!file) return
      if (file.size / 1048576 > 20) {
        this.$store.commit('notifications/ADD', {
          type: 'error',
          message: this.$t('error_document-specification-upload-file-too-big'),
        })
        this.$refs.file.value = null
        return
      }
      if (
        file.name
          .split('.')
          .pop()
          .toLowerCase() !== 'csv'
      ) {
        this.$store.commit('notifications/ADD', {
          type: 'error',
          message: this.$t('error__goods_upload_wrong_extension'),
        })
        return
      }
      // this.checkFileFormat(file).then(response => {
      //   if (response) {
      //     this.file = file
      //     this.valid = true
      //   }
      // })
      this.file = file
      this.valid = true
      this.$refs.file.value = null
    },
    checkFileFormat(file) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.onloadend = () => {
          let firstRow = reader.result.split('\n').shift()
          const format = this.formats[this.group - 1]
          if (!format) resolve(true)
          else if (firstRow !== format) {
            this.$store.commit('notifications/ADD', {
              type: 'error',
              message: this.$t('error__goods_upload_wrong_format'),
            })
            resolve(false)
          }
          resolve(true)
        }
        reader.readAsText(file)
      })
    },
    close() {
      this.group = null
      this.file = null
      this.result = null
      this.$emit('close-modal')
    },
    upload() {
      this.loading = true
      api
        .uploadGoodsCSV(this.group, this.file)
        .then(response => {
          this.result = response
          this.$emit('upload-complete')
        })
        .catch(() => {
          this.$store.commit('notifications/ADD', {
            type: 'error',
            message: this.$t('error__goods_upload_wrong_format'),
          })
        })
        .then(() => {
          this.loading = false
        })
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500"
  >
    <v-card
      v-show="loading && !result"
      color="primary"
      dark
    >
      <v-card-text>
        Loading..
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        />
      </v-card-text>
    </v-card>
    <v-card v-show="!loading && !result">
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__upload_goods') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-select
          :items="goodsGroup"
          :label="$t('dictionaries__goodsgroup')"
          v-model="group"
          :rules="rules.isRequired"
          item-text="name"
          item-value="code"
          required
          autocomplete
        />
        <v-layout
          row
          wrap
          align-center>
          <v-flex shrink>
            <v-btn
              :disabled="!group"
              color="primary"
              class="ml-0"
              @click="$refs.file.click()"
            >
              Choose file
            </v-btn>
          </v-flex>
          <v-flex>
            {{ file ? file.name : null }}
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="close()">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :disabled="!file || !valid || loading"
          :loading="loading"
          color="success"
          @click="upload()">{{ $t('buttons__upload') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      v-if="!loading && result"
    >
      <v-card-text>
        <v-expansion-panel>
          <v-expansion-panel-content v-if="Object.keys(result.failure).length">
            <div
              slot="header"
              class="headline">{{ $t('titles__failure') }}: {{ Object.keys(result.failure).length }}</div>
            <v-card>
              <v-card-text>
                <p
                  v-for="(item, index) in result.failure"
                  :key="item.id"
                >
                  {{ index }}: {{ item }}
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="Object.keys(result.success).length">
            <div
              slot="header"
              class="headline">{{ $t('titles__success') }}: {{ Object.keys(result.success).length }}</div>
            <v-card>
              <v-card-text>
                <p
                  v-for="item in result.success"
                  :key="item.id"
                >
                  {{ item.fullName }}
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click="close()">{{ $t('buttons__close') }}</v-btn>
      </v-card-actions>
    </v-card>
    <input
      ref="file"
      class="fileInput"
      accept=".csv"
      type="file"
      name="file"
      @change="onFilePicked"
    >
  </v-dialog>
</template>

<style lang="scss" scoped>
.fileInput {
  position: absolute;
  left: -99999px;
}
</style>
